legends__header<template>
  <div>
    <accordion-panel
      class="chart-legends"
      header-class="chart-legends__header"
      :id="chartId"
      :collapsed.sync="collapsed"
    >
      <template #title>
        <strong> {{ $t('general.chart-legends') }} </strong>
      </template>
      <b-checkbox
        class="chart-legends__toggle-all"
        :checked="isAllLegendsSelected"
        @change="checkAllLegends"
      />
      <span>
        {{ $t('general.mark-chart-variables') }}
      </span>
      <ul class="chart-legends__list">
        <li
          v-for="(values, key) in orderedItems"
          :key="key"
          class="chart-legends__list-item"
        >
          <div :class="{ 'chart-legends__disabled': isLegendHidden(key) }">
            <b-checkbox
              class="chart-legends__checkbox"
              :checked="!isLegendHidden(values)"
              @change="newValue => toggleLegend(values, newValue)"
            />
            <span
              class="chart-legends__color"
              :style="getColorStyle(values[0].chartColor)"
            />
            <span class="chart-legends__checkbox-label">
              {{ key }}
            </span>
          </div>
        </li>
      </ul>
    </accordion-panel>

    <accordion-panel
      v-if="!hideManeuversSection"
      class="chart-legends mt-4 pa-0"
      header-class="chart-legends__header"
      :id="chartId"
      :withMarginHeader="false"
      :collapsed.sync="secondPanelCollapsed"
      :hasControlsSlot="true"
    >
      <template #controls>
        <b-dropdown-item @click="toogleAccordions()">
          {{
            isAllExpanded ? $t('actions.retract-all') : $t('actions.expand-all')
          }}
        </b-dropdown-item>
      </template>
      <template #title>
        <b-row class="align-items-center py-4">
          <b-col cols="1">
            <b-checkbox
              class="chart-legends__toggle-all"
              :checked="isAllManeuversSelected"
              @change="checkAllManeuvers"
            />
          </b-col>
          <b-col v-if="oscillographyChartType === oscillographyChartTypes.OSCILLOGRAPHY" cols="2">
            <div
              class="preview justify-center align-center"
              :style="{background: background}"
            >
              <strong
                :style="{background: background}"
              >{{
                $t('reports.oscillography.view-report.graphic-line')
              }}</strong>
            </div>
          </b-col>
          <b-col cols="2">
            <strong>
              {{ $t('reports.oscillography.view-report.maneuver') }}
            </strong>
          </b-col>
          <b-col cols="2">
            <strong>
              {{ $t('reports.oscillography.view-report.datetime') }}
            </strong>
          </b-col>
          <b-col cols="2">
            <strong>
              {{ $t('reports.oscillography.view-report.asset') }}
            </strong>
          </b-col>
          <b-col cols="2">
            <strong>
              {{ $t('reports.oscillography.view-report.installation') }}
            </strong>
          </b-col>
          <b-col v-if="oscillographyChartType
          === oscillographyChartTypes.OSCILLOGRAPHY" cols="1">
            <strong>
              {{ $t('reports.oscillography.view-report.company') }}
            </strong>
          </b-col>
          <b-col v-else-if="oscillographyChartType
          === oscillographyChartTypes.DIAGNOSTICS" cols="2">
            <strong>
              {{ $t('reports.oscillography.view-report.company') }}
            </strong>
          </b-col>
          <b-col v-if="oscillographyChartType
          === oscillographyChartTypes.DIAGNOSTICS" cols="1">
            <strong>
              {{ $t('reports.oscillography.view-report.module') }}
            </strong>
          </b-col>
        </b-row>
      </template>

      <ul class="px-0">
        <li
          v-for="(item, index) in maneuverDataFiltered"
          class="chart-legends__list-item px-0"
          :key="index"
        >
            <accordion-panel
            class="pa-0"
            header-class="pa-0"
            :id="`chart-item-${index}`"
            :collapsed="collapsedItems[index]"
            @update:collapsed="toggleCollapse(index)"
            @update:collapsedprint="toggleCollapsePrint(index)"
            >
            <template #title>
              <b-row class="align-items-center">
                <b-col cols="1">
                  <b-checkbox
                    class="chart-legends__toggle-all"
                    :checked="isManeuverHidden(getManeuverKey(item))"
                    @change="
                      newValue => toggleManeuvers(getManeuverKey(item), newValue)
                    "
                  />
                </b-col>
                <b-col cols="2" v-if="oscillographyChartType
                === oscillographyChartTypes.OSCILLOGRAPHY">
                  <div
                    v-if="bookmarks"
                    class="preview"
                    v-html="previewContent(
                      item.preview.lineTypesBookmark,
                      item.preview.lineWidth,
                      item.preview.lineSymbols,
                      item.preview.lineSymbolColor
                    )"
                  />
                  <div
                    v-else
                    class="preview"
                    v-html="previewContent(item.preview.lineTypes, 1, 'none', 'none')"
                  />
                </b-col>
                <b-col cols="2">
                  <span> {{ item.name }} </span>
                </b-col>
                <b-col cols="2">
                  <strong>
                    {{ formatDateTime(item.dateTimeOscillography) }}
                  </strong>
                </b-col>
                <b-col cols="2">
                  <strong> {{ item.assetName }} </strong>
                </b-col>
                <b-col cols="2">
                  <strong> {{ item.installationName }} </strong>
                </b-col>
                <b-col v-if="oscillographyChartType
                === oscillographyChartTypes.OSCILLOGRAPHY" cols="1">
                  <strong> {{ item.companyName }} </strong>
                </b-col>
                <b-col v-else-if="oscillographyChartType
                === oscillographyChartTypes.DIAGNOSTICS" cols="2">
                  <strong> {{ item.companyName }} </strong>
                </b-col>
                <b-col v-if="oscillographyChartType
                === oscillographyChartTypes.DIAGNOSTICS" cols="1">
                  <strong> {{ item.moduleName }} </strong>
                </b-col>
              </b-row>
            </template>
            <div v-if="!collapsedItems[index]">
              <b-badge
                class="assetBadge"
                pill
                v-for="item in filteredAssetInfo(index)"
                :key="item.key"
              >
                {{ $t(`reports.oscillography.asset-info.${item.key}`) }}:
                {{ formatValue(item.value) }}
              </b-badge>
            </div>
          </accordion-panel>
        </li>
      </ul>
    </accordion-panel>
  </div>
</template>

<script>
import { getColorsListByLength } from '@/domain/data/charts/chartColors';
import AccordionPanel from '@/components/AccordionPanel';
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/common';
import { formatter as dateTimeFormatter } from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';
import themeService from '@/services/themeService';
import { mapGetters } from 'vuex';
import oscillographyChartTypes from '@/domain/enums/oscillographyChartTypes';

export default {
  name: 'OscillographyChartLegends',
  props: {
    items: {
      type: Array,
      required: true,
    },
    hiddenLegends: {
      type: Array,
      default: () => [],
    },
    chartId: {
      type: String,
      required: true,
    },
    itemsUniqueProperty: {
      type: String,
      default: 'name',
    },
    colorsList: {
      type: Array,
    },
    startCollapsed: {
      type: Boolean,
      default: false,
    },
    oscillographyChartType: {
      type: String,
      default: oscillographyChartTypes.OSCILLOGRAPHY,
    },
    maneuverData: {
      type: Array,
      default: () => [],
    },
    bookmarks: {
      type: Boolean,
      default: true,
    },
    hideManeuversSection: {
      type: Boolean,
      default: false,
    },
  },
  components: { AccordionPanel },
  data: vm => ({
    collapsed: vm.startCollapsed,
    secondPanelCollapsed: vm.startCollapsed,
    allLegendsSelected: true,
    allManeuversSelected: true,
    loading: false,
    collapsedItems: {},
    activeManeuvers: [],
    activeLegends: [],
    maneuverDataFiltered: [],
    oscillographyChartTypes,
  }),
  computed: {
    referenceVariablesExists() {
      return this.items.some(item => item.fieldType === 'oscillography_reference');
    },
    orderedItems() {
      const result = this.getItemsWithColors();
      return result;
    },

    isAllLegendsSelected() {
      if (this.oscillographyChartType === oscillographyChartTypes.DIAGNOSTICS) {
        return this.hiddenLegends.length === 0;
      }

      if (this.activeManeuvers.length === 0) {
        return false;
      }

      const variablesFromActiveManeuvers = Object.values(this.orderedItems)
        .flat()
        .filter(item => this.activeManeuvers.includes(this.getChartItemManeuverKey(item)));

      if (variablesFromActiveManeuvers.length === 0) {
        return false;
      }

      return variablesFromActiveManeuvers.every(variable => (
        !this.hiddenLegends.includes(variable.name)
      ));
    },
    isAllManeuversSelected() {
      const maneuvers = this.maneuverDataFiltered.map(this.getManeuverKey);
      return maneuvers.every(item => this.activeManeuvers.includes(item));
    },
    chartColors() {
      return getColorsListByLength(this.items.length, this.colorsList);
    },
    isAllExpanded() {
      return (
        Object.keys(this.collapsedItems).length > 0
        && Object.values(this.collapsedItems).every(item => !item)
      );
    },
    background() {
      return themeService.isDarkTheme() ? 'var(--color-background-dark)' : 'var(--color-neutral-background)';
    },
    ...mapGetters([
      'isPrinting',
    ]),
  },
  mounted() {
    if (this.referenceVariablesExists) {
      this.maneuverDataFiltered = this.maneuverData;
    } else {
      this.maneuverDataFiltered = this.maneuverData.filter(maneuver => !maneuver.isReference);
    }
    this.activeManeuvers = this.maneuverDataFiltered.map(
      this.getManeuverKey,
    );
    this.activeLegends = this.items.map(legend => legend.name);
  },
  created() {
    this.initListeners();
    this.collapsedItems = this.maneuverData.reduce((acc, _, index) => {
      acc[index] = true;
      return acc;
    }, {});
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    filteredAssetInfo(index) {
      const assetInfo = this.maneuverDataFiltered[index]?.assetInfo || [];
      return assetInfo.filter(item => item.value !== null && item.value !== '');
    },
    getManeuverKey(maneuver) {
      return maneuver.maneuverKey || maneuver.maneuverUUID;
    },
    getChartItemManeuverKey(item) {
      return item.maneuverKey || item.oscillographyUUID;
    },
    previewContent(typeLine, width, symbol, symbolColor) {
      let typeSymbol = '';

      switch (symbol) {
        case 'circle':
          typeSymbol = `<circle cx="50%" cy="10" r="10" fill="${symbolColor}" />`;
          break;
        case 'rect':
          typeSymbol = `<rect width="14" height="14" x="40%" y="2" style="fill:${symbolColor};stroke-width:3;" />`;
          break;
        case 'triangle':
          typeSymbol = `<polygon points="38,0 45,20 30,20" style="fill:${symbolColor};stroke-width:3" />`;
          break;
        case 'diamond':
          typeSymbol = `<polygon points="38,0 50,10 38,20 26,10" style="fill:${symbolColor};stroke-width:3" />`;
          break;
        default:
          typeSymbol = '';
      }

      return `
        <svg width="100%" height="20">
          <line x1="0" y1="10" x2="100%" y2="10"
            stroke="${this.getStrokeColor()}"
            stroke-width="${!width ? 6 : width}"
            stroke-linejoin="bevel"
            stroke-dasharray="${!typeLine ? '' : typeLine}"
          />${typeSymbol}
        </svg>
      `;
    },
    getStrokeColor() {
      if (this.isPrinting) return '#000';
      return themeService.isDarkTheme() ? '#FFF' : '#000';
    },
    handleAccordionOnPrint() {
      const originalState = this.collapsed;
      window.onbeforeprint = () => {
        this.openAccordion();
      };
      window.onafterprint = () => {
        this.collapsed = originalState;
      };
    },
    handleSecondPanelAccordionOnPrint() {
      const originalState = this.secondPanelCollapsed;
      window.onbeforeprint = () => {
        this.openAccordion();
      };
      window.onafterprint = () => {
        this.secondPanelCollapsed = originalState;
      };
    },
    openAccordion() {
      this.collapsed = false;
    },
    openSecondPanelAccordion() {
      this.secondPanelCollapsed = false;
    },
    initListeners() {
      eventBus.on(events.print, this.openAccordion);
    },
    removeListeners() {
      eventBus.off(events.print, this.openAccordion);
    },
    getVisibilityStyle(variable) {
      return {
        display: (variable.values || []).length ? 'block' : 'none',
      };
    },
    getColorStyle(color) {
      return {
        'background-color': color,
      };
    },
    toggleLegend(values, isChecked) {
      if (this.oscillographyChartType === oscillographyChartTypes.DIAGNOSTICS) {
        if (!isChecked) {
          this.activeLegends = this.activeLegends.filter(
            legend => !values.some(v => v.name === legend),
          );
          this.$emit('toggle-legend', values);
        } else {
          this.activeLegends = [
            ...this.activeLegends,
            ...values.map(item => item.name),
          ];
          this.$emit('toggle-legend', values);
        }
        return;
      }

      const actives = this.activeLegends.filter(legend => legend.includes(values[0].name.split(' - ')[4]));

      if (!isChecked) {
        const filteredValues = values.filter(
          value => !this.hiddenLegends.includes(value.name),
        );

        this.activeLegends = this.activeLegends.filter(
          legend => !actives.includes(legend),
        );
        this.$emit('toggle-legend', filteredValues);

        const affectedManeuvers = [...new Set(values.map(this.getChartItemManeuverKey))];
        affectedManeuvers.forEach(maneuverKey => {
          if (this.shouldDeactivateManeuver(maneuverKey)) {
            this.activeManeuvers = this.activeManeuvers.filter(
              activeManeuverKey => activeManeuverKey !== maneuverKey,
            );
          }
        });
      } else {
        this.activeLegends = [
          ...this.activeLegends,
          ...values.map(item => item.name),
        ];

        const variablesToShow = values
          .filter(value => this.hiddenLegends.includes(value.name))
          .filter(value => this.activeManeuvers.includes(
            this.getChartItemManeuverKey(value),
          ));

        this.$emit('toggle-legend', variablesToShow);

        const affectedManeuvers = [...new Set(values.map(this.getChartItemManeuverKey))];
        affectedManeuvers.forEach(maneuverKey => {
          const hasActiveVars = this.hasActiveVariablesForManeuver(maneuverKey);
          const isNotActive = !this.activeManeuvers.includes(maneuverKey);
          if (hasActiveVars && isNotActive) {
            this.activeManeuvers = [...this.activeManeuvers, maneuverKey];
          }
        });
      }
    },
    toggleManeuvers(maneuverKey, isChecked) {
      if (!maneuverKey) return;
      this.$emit('toggle-maneuver', maneuverKey);
      if (this.oscillographyChartType === oscillographyChartTypes.DIAGNOSTICS) {
        if (!isChecked) {
          this.activeManeuvers = this.activeManeuvers.filter(
            activeManeuverKey => activeManeuverKey !== maneuverKey,
          );

          if (this.activeManeuvers.length === 0) {
            const allVisibleVariables = Object.values(this.orderedItems)
              .flat()
              .filter(item => !this.hiddenLegends.includes(item.name));

            if (allVisibleVariables.length > 0) {
              this.$emit('toggle-legend', allVisibleVariables);
            }
          }
        } else {
          this.activeManeuvers = [...this.activeManeuvers, maneuverKey];

          this.$nextTick(() => {
            const variablesToShow = Object.values(this.orderedItems)
              .flat()
              .filter(item => this.activeLegends.includes(item.name)
                && this.hiddenLegends.includes(item.name));

            if (variablesToShow.length > 0) {
              this.$emit('toggle-legend', variablesToShow);
            }
          });
        }
        return;
      }
      const values = Object.values(this.orderedItems)
        .flat()
        .filter(item => this.getChartItemManeuverKey(item) === maneuverKey);
      if (!isChecked) {
        const currentManeuvers = this.activeManeuvers.filter(
          activeManeuverKey => activeManeuverKey !== maneuverKey,
        );
        this.activeManeuvers = currentManeuvers;
        const filteredValues = values.filter(
          // eslint-disable-next-line comma-dangle
          value => !this.hiddenLegends.includes(value.name),
        );
        this.$emit('toggle-legend', filteredValues);
      } else {
        this.activeManeuvers = [...this.activeManeuvers, maneuverKey];
        const variablesToShow = values
          .filter(value => this.activeLegends.includes(value.name))
          .filter(value => this.hiddenLegends.includes(value.name));

        this.$emit('toggle-legend', variablesToShow);
      }
    },
    isLegendHidden(values) {
      if (!Array.isArray(values)) {
        return false;
      }
      const variables = values.map(value => value[this.itemsUniqueProperty]);
      return variables.every(variable => this.hiddenLegends.includes(variable));
    },
    isManeuverHidden(maneuverKey) {
      return this.activeManeuvers.includes(maneuverKey);
    },
    checkAllLegends(event) {
      if (event) {
        if (this.oscillographyChartType === oscillographyChartTypes.DIAGNOSTICS) {
          this.activeLegends = Object.values(this.orderedItems).flat().map(item => item.name);
          this.$emit('select-all-legends');
          return;
        }

        this.activeLegends = [
          ...this.activeLegends,
          ...Object.values(this.orderedItems).flat().map(item => item.name),
        ];

        const variablesToShow = Object.values(this.orderedItems)
          .flat()
          .filter(item => this.activeManeuvers.includes(this.getChartItemManeuverKey(item))
            && this.hiddenLegends.includes(item.name));

        this.$emit('toggle-legend', variablesToShow);
        return;
      }

      this.activeLegends = [];
      this.$emit('unselect-all-legends');

      if (this.oscillographyChartType !== oscillographyChartTypes.DIAGNOSTICS) {
        const maneuversToDeactivate = this.activeManeuvers.filter(maneuverKey => (
          this.shouldDeactivateManeuver(maneuverKey)
        ));

        this.activeManeuvers = this.activeManeuvers.filter(maneuverKey => (
          !maneuversToDeactivate.includes(maneuverKey)
        ));
      }
    },
    checkAllManeuvers(event) {
      if (event) {
        this.activeManeuvers = this.maneuverDataFiltered.map(
          this.getManeuverKey,
        );
        this.allManeuversSelected = true;

        if (this.oscillographyChartType === oscillographyChartTypes.DIAGNOSTICS) {
          this.$emit('toggle-all-maneuvers', true);

          this.$nextTick(() => {
            const variablesToShow = Object.values(this.orderedItems)
              .flat()
              .filter(item => this.activeLegends.includes(item.name)
                && this.hiddenLegends.includes(item.name));

            if (variablesToShow.length > 0) {
              this.$emit('toggle-legend', variablesToShow);
            }
          });
          return;
        }

        const variablesToShow = Object.values(this.orderedItems)
          .flat()
          .filter(item => this.activeLegends.includes(item.name)
            && this.hiddenLegends.includes(item.name));
        this.$emit('toggle-legend', variablesToShow);
        return;
      }

      this.allManeuversSelected = false;
      this.activeManeuvers = [];

      if (this.oscillographyChartType === oscillographyChartTypes.DIAGNOSTICS) {
        this.$emit('toggle-all-maneuvers', false);

        const allVisibleVariables = Object.values(this.orderedItems)
          .flat()
          .filter(item => !this.hiddenLegends.includes(item.name));

        if (allVisibleVariables.length > 0) {
          this.$emit('toggle-legend', allVisibleVariables);
        }
        return;
      }

      const allVisibleVariables = Object.values(this.orderedItems)
        .flat()
        .filter(item => !this.hiddenLegends.includes(item.name));
      this.$emit('toggle-legend', allVisibleVariables);
    },
    shouldDeactivateManeuver(maneuverKey) {
      const maneuverVariables = Object.values(this.orderedItems)
        .flat()
        .filter(item => this.getChartItemManeuverKey(item) === maneuverKey);

      return maneuverVariables.every(variable => this.hiddenLegends.includes(variable.name));
    },
    hasActiveVariablesForManeuver(maneuverKey) {
      const maneuverVariables = Object.values(this.orderedItems)
        .flat()
        .filter(item => this.getChartItemManeuverKey(item) === maneuverKey);

      return maneuverVariables.some(variable => !this.hiddenLegends.includes(variable.name));
    },
    getItemsWithColors() {
      let filteredItems;
      if (this.oscillographyChartType === oscillographyChartTypes.DIAGNOSTICS) {
        filteredItems = this.items.filter(item => Array.isArray(item.values));
      } else {
        filteredItems = this.items.filter(item => Array.isArray(item.values)
        && item.values.length > 0);
      }
      const groupedItems = filteredItems.reduce((acc, item) => {
        const { variableName } = item;

        if (!acc[variableName]) {
          acc[variableName] = [];
        }
        acc[variableName].push(item);

        return acc;
      }, {});

      const sortedGroupedItems = Object.keys(groupedItems)
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' }))
        .reduce((acc, key) => {
          acc[key] = groupedItems[key];
          return acc;
        }, {});

      const groupedItemsWithColors = Object.keys(sortedGroupedItems).map(
        (variableName, index) => {
          const groupItems = sortedGroupedItems[variableName];
          const colorList = getColorsListByLength(
            Object.keys(sortedGroupedItems).length,
          );
          const color = colorList[index];
          return groupItems.map(item => ({
            ...item,
            chartColor: color,
          }));
        },
      );

      const finalGroupedItems = groupedItemsWithColors.reduce(
        (acc, groupItems) => {
          const { variableName } = groupItems[0];
          acc[variableName] = groupItems;
          return acc;
        },
        {},
      );

      return finalGroupedItems;
    },

    toggleCollapse(index) {
      this.$set(this.collapsedItems, index, !this.collapsedItems[index]);
    },
    toggleCollapsePrint(index) {
      this.$set(this.collapsedItems, index, false);
    },
    toogleAccordions() {
      if (this.isAllExpanded) {
        this.collapsedItems = this.maneuverDataFiltered.reduce((acc, _, index) => {
          acc[index] = true;
          return acc;
        }, {});
      } else {
        this.collapsedItems = this.maneuverDataFiltered.reduce((acc, _, index) => {
          acc[index] = false;
          return acc;
        }, {});
      }
    },
    formatValue(value) {
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(value)) {
        return value;
      }
      if (this.isDate(value)) {
        return this.formatDateTime(value);
      }
      return value;
    },
    isDate(value) {
      // eslint-disable-next-line no-restricted-globals
      return !isNaN(Date.parse(value));
    },
    formatDateTime(dateTime) {
      return dateTimeFormatter(dateTime, formats.DATETIME_SHORT_WITH_SECONDS);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
.chart-legends
  border: 1px solid $color-border-gray
  border-radius: 5px
  ::v-deep &__header
    min-height: 25px
    padding: 0 15px !important
    background-color: $color-gray-medium-light
  &__disabled
    opacity: .5
  &__list
    position: relative
    padding-left: 20px
    column-count: 2
    list-style-type: none
    margin-bottom: 0
    +media-max-md
      column-count: 1
  &__checkbox
    display: inline-flex
    vertical-align: middle
  &__list-item
    margin-bottom: 10px
    display: flex
    align-items: center
  &__toggle-all
    margin-bottom: 10px
    margin-left: 20px
    display: inline-block
  &__checkbox-label
    vertical-align: middle
    white-space: normal
    word-break: break-word
  &__accordion-label
    font-size: 0.8rem
  &__color
    display: inline-block
    vertical-align: middle
    margin: 5px 3px 5px 0
    width: 15px
    height: 15px
.preview
    width: 85px
    height: 50px
    border: 1px solid $color-border-gray
    padding: 5px
    display: flex
    align-items: center
    justify-content: center
    text-align: center
    & strong
      font-size: 0.8rem
.assetBadge
  background-color: $color-gray-medium-highlight
  margin-left: 5px
</style>
